<template>
  <div id="bjzc-about">
    <PageHeading>{{ $t('about.name') }}</PageHeading>
    <div uk-grid="" class="uk-grid-collapse bjzc-page-content">
      <div class="bjzc-about--text border-radius uk-width-1-1 uk-width-3-5@m" v-html="$t('about.content')"></div>
      <div class="bjzc-about--image uk-width-1-1 uk-width-2-5@m uk-grid-small" uk-grid>
        <div class="uk-width-1-1 uk-cover-container border-radius" style="">
          <img src="~@/assets/images/about-1.png" alt="" uk-cover />
        </div>
        <div class="uk-width-1-2 uk-cover-container border-radius">
          <img src="~@/assets/images/about-2.png" alt="" uk-cover />
        </div>
        <div class="uk-width-1-2 uk-cover-container border-radius">
          <img src="~@/assets/images/about-3.png" alt="" uk-cover />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$eventBus.$emit('setBreadcrumb', [
      { path: '/', title: '首页', title_en: 'Home' },
      {
        path: '/about',
        title: this.$t('breadcrumb.about', 'zh'),
        title_en: this.$t('breadcrumb.about', 'en')
      }
    ])
  }
}
</script>

<style lang="scss">
#bjzc-about {
  .bjzc-about--text {
    padding: 2.5rem;
    background-color: #fff;
  }
  .bjzc-about--image {
    margin-left: 0;
    & > div {
      min-height: 6.56rem;
      max-height: 10rem;
      &:nth-child(1) {
        min-height: 13.75rem;
        max-height: 20rem;
      }
    }
  }
}

@media (max-width: ($screen-width-m - 1)) {
  #bjzc-about {
    .bjzc-about--text {
      padding: 0;
      padding-bottom: 1.88rem;
    }
  }
}
</style>
